import { removeVehicle } from "../../../store/slices/vehicleSlice";

export default function responseDeleteVehicle(response: any, api: any, arg: any) {
    console.log('delete vehicle response', response);
    if (response?.data) {
        api.dispatch(removeVehicle(arg.arguments?.id));
    }
    return response?.data || null;
}